import { render, staticRenderFns } from "./DetailLeftView.vue?vue&type=template&id=8da27e88&scoped=true&"
import script from "./DetailLeftView.vue?vue&type=script&lang=js&"
export * from "./DetailLeftView.vue?vue&type=script&lang=js&"
import style0 from "./DetailLeftView.vue?vue&type=style&index=0&id=8da27e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da27e88",
  null
  
)

export default component.exports